import {Input, inputClasses, styled} from "@mui/material";
import React from "react";


export const TreeInput = styled((props) => (
    <Input {...props}/>
))(({theme}) => ({
    ".MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: theme.palette.text.primary,
        color: theme.palette.text.primary,
    },
    [`& .${inputClasses.input}`]: {
        color: theme.palette.text.primary,
        fontSize: theme.typography.body2.fontSize,
    },
}));